import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from '@famly/mf_data-display_text';
import { Stack } from '@famly/mf_layout_stack';
import { useBreakpoints } from '@famly/mf_util_breakpoints';
import { PersonImage } from 'signin-app/components/person-image';
export const HeaderPerson = ({ image, initials, name }) => {
    const { isTabletLandscapeAndLarger } = useBreakpoints();
    return (_jsxs(Stack, { alignItems: "center", flexDirection: isTabletLandscapeAndLarger ? 'row' : 'column', gap: 3, children: [_jsx(PersonImage, { size: "sm", image: image, initials: initials }), _jsx(Text, { variant: "h5", color: "n400", emphasized: true, "data-e2e-id": "head-person-name", children: name })] }));
};
